<template>
  <div class="loginContainer">
    <img alt="" class="logo" src="/svg/logo--white.svg" />

    <div class="loginBox">
      <!--        <h1 class="text-sm-h2 text-center text-main">Connection</h1>-->

      <div class="mb-4">
        <label
          class="block text-gray-700 text-sm font-bold mb-2"
          for="username"
        >
          <!--          Username-->
        </label>
        <input
          id="username"
          v-model="email"
          :disabled="loading"
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          placeholder="Email"
          type="text"
        />
      </div>

      <div class="mb-6">
        <label
          class="block text-gray-700 text-sm font-bold mb-2"
          for="password"
        >
          <!--                    Password-->
        </label>
        <input
          id="password"
          v-model="password"
          :disabled="loading"
          class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
          placeholder="Mot de passe"
          type="password"
        />
        <p
          style="
            text-align: center;
            font-weight: 500;
            opacity: 0.7;
            color: white;
          "
        >
            Mot de passe oublié ?
            <router-link class="forgot-password-link"
                         :to="{'name': 'forgotPassword'}">Cliquez ici pour le réinitialiser !</router-link>
        </p>
      </div>

      <div class="flex items-center justify-center">
        <div :disabled="loading" class="loginButton" @click="submit">
          <img alt="" class="buttonImg" src="svg/lemon.svg" />
          <p class="textButton">GO!</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { notifyRaw } from "@/helper";
import { api, API_ROUTES } from "@/Services/api.common.service";
import { tokenKey } from "@/setup.const";
import Vue from "vue";
import { mapMutations } from "vuex";

export default Vue.extend({
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      loading: false,
    };
  },
  mounted() {
    if (this.$route.query.token) this.setToken(this.$route.query.token);
  },
  methods: {
    async setToken(token) {
      const notify = notifyRaw.bind(this);
      const setAccount = async () => {
        const {
          data: { account },
        } = await api().get(API_ROUTES.auth.account);

        this.setAccount({ account });
        return account;
      };

      try {
        localStorage.setItem(tokenKey, token);
        const account = await setAccount();
        notify("Vous êtes connecté :)", "success");

        if (account.role === "ROLE_ADMIN") {
          await this.$router.push({ name: "adminText" });
        } else {
          await this.$router.push({ name: "home" });
        }
      } catch (e) {
        console.error(e);
        localStorage.clear();
        notify("Mauvais token", "error");
      }
    },
    async submit() {
      this.loading = true;
      const notify = notifyRaw.bind(this);

      const getToken = async () => {
        const {
          data: { token },
        } = await api().post(API_ROUTES.auth.login, {
          email: this.email,
          password: this.password,
        });

        localStorage.setItem(tokenKey, token);
      };

      const setAccount = async () => {
        const {
          data: { account },
        } = await api().get(API_ROUTES.auth.account);

        this.setAccount({ account });
        return account;
      };

      try {
        await getToken();
        const account = await setAccount();
        notify("Vous êtes connecté :)", "success");

        if (this.$route.query.redirect) {
          await this.$router.replace(this.$route.query.redirect);
        } else if (account.role === "ROLE_ADMIN") {
          await this.$router.push({ name: "adminText" });
        } else {
          await this.$router.push({ name: "home" });
        }
      } catch (e) {
        console.error(e);
        localStorage.clear();
        notify("Mauvais identifiants", "error");
      }

      this.loading = false;
    },
    ...mapMutations(["setAccount"]),
  }
});
</script>

<style lang="css" scoped>
.loginButton {
  cursor: pointer;
  position: relative;
}

.textButton {
  color: white;
  font-size: 24px;
  font-weight: bold;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-56%, -20%);
}

.logo {
  height: 100%;
  margin-bottom: 100px;
  max-height: 250px;
}

.loginBox {
  max-width: 400px;
  width: 50%;
}

input {
  background: white;
  font-size: 20px;
  line-height: 30px;
}

.loginContainer {
  @apply mx-auto flex flex-col justify-center items-center h-screen bg-main;
  width: 100%;
}

.forgot-password-link {
    font-weight: bold;
}
</style>
